// Static landing route integrating LandingPage
import React from "react";
import LandingPage from "./landing/LandingPage";
import { Box } from "@mui/material";

export default function StaticPage() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: " ",
        justifyContent: "flex-start",
        // Add a bit more right padding on mobile to avoid edge hugging
        // px: { xs: 2.5, sm: 0 },
        // pr: { xs: 3.5, sm: 0 },
        boxSizing: "border-box",
        width: "100%",
        // overflowX: "hidden",
      }}
    >
      <LandingPage />
    </Box>
  );
}
